//import React from 'react';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import FormControl from '@material-ui/core/FormControl';
import Grid from '@material-ui/core/Grid';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Checkbox from '@material-ui/core/Checkbox';
import CircularProgress from '@material-ui/core/CircularProgress';
import Drawer from '@material-ui/core/Drawer';
import PropTypes from 'prop-types';
import withWidth from '@material-ui/core/withWidth';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import DoneIcon from '@material-ui/icons/Done';
import EmailIcon from '@material-ui/icons/Email';
import SaveIcon from '@material-ui/icons/Save';
import AddIcon from '@material-ui/icons/Add';
import Tooltip from '@material-ui/core/Tooltip';

import OnCallScheduleItem from './OnCallScheduleItem';
import scheduleActions from '../actions/schedule_actions';

export class OnCallScheduleList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      user: this.props.user,
      members: this.props.members,
      memberIdMap: this.props.memberIdMap,
      memberNameMap: this.props.memberNameMap,
      schedule: this.props.schedule,
      numOfRows: 0,
      company: "Select",
      sendEmailOpen: false,
      checked: {},
      buttonLoading: false,
      buttonSuccess: false,
      currentSchedule: {},
      newSchedule: {},
      newScheduleOnCallLineItem: {},
    };
  }

  componentDidMount() {
    this.props.getSchedule(); // [{company: "Da Vinci", creationDate: "...", id: "....", onCallLineItems: [{beginTime, endTime, id, scheduleId, prime, secondary, tertiary}, {...}, {...}]}, {...}]
  }

  componentWillUnmount() {
    clearTimeout(this.timer);
  }

  uuidv4 = () => {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  }

  handleButtonClick = () => {
    if (!this.state.buttonLoading) {
      this.setState(
        {
          buttonSuccess: false,
          buttonLoading: true,
        },
        () => {
          this.timer = setTimeout(() => {
            this.setState({
              buttonLoading: false,
              buttonSuccess: true,
            });
          }, 1500);
          this.timer = setTimeout(() => {
            this.setState({
              sendEmailOpen: false,
            });
          }, 2000);
        },
      );
    }
  };

  handleRemove = () => {
    console.log("removed");
  };

  handleAddTimeframe = () => {
    //this.setState({
    //  numOfRows: this.state.numOfRows + 1
    //});
    console.log("trying to add timeframe");
    var tempSchedule = { ...this.state.currentSchedule }
    var today = new Date();
    var dd = String(today.getDate()).padStart(2, '0');
    var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
    var yyyy = today.getFullYear();
    var datePrefix = yyyy + "-" + mm + "-" + dd + "T";
    tempSchedule.onCallLineItems.push({ 'id': this.uuidv4(), /*'beginTime': datePrefix + "10:00:00", 'endTime': datePrefix + "10:00:00",*/ 'beginTime': '', 'endTime': '', 'prime': "", 'secondary': "", 'tertiary': ""})
    this.setState({ currentSchedule: tempSchedule }, () => { // upsert this.state.currentSchedule
      console.log("this.state.currentSchedule ADD NEW ROW: ", this.state.currentSchedule);
    });
  };

  handleSendEmail = () => {
    console.log("SEND EMAIL");
    this.setState({ sendEmailOpen: true });
  };

  handleSendEmailClose = () => {
    this.setState({ sendEmailOpen: false, buttonSuccess: false });
  };

  handleSendEmailSent = () => {
    console.log("EMAIL SENT");
    console.log(this.state.currentSchedule);
    console.log(this.state.company);
    this.props.sendEmail(this.state.company, this.state.currentSchedule);
    this.setState({ sendEmailOpen: false });
  };

  handleSaveOnCall = () => {
    if (this.state.company === "Select") {
      return;
    }
    var today = new Date();
    var dd = String(today.getDate()).padStart(2, '0');
    var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
    var yyyy = today.getFullYear();
    var datePrefix = yyyy + "-" + mm + "-" + dd + "T";

    var tempSchedule = { ...this.state.currentSchedule }
    for (var i = 0; i < tempSchedule.onCallLineItems.length; i++) {
      var lineItem = tempSchedule.onCallLineItems[i];
      lineItem['beginTime'] = datePrefix + lineItem['beginTime'].split("T").pop();
      lineItem['endTime'] = datePrefix + lineItem['endTime'].split("T").pop();
      tempSchedule.onCallLineItems[i] = lineItem;
    }

    this.props.updateSchedule(this.state.company, this.state.currentSchedule);

    this.setState({ currentSchedule: tempSchedule, open: false }, () => { // upsert this.state.currentSchedule
      console.log("this.state.currentSchedule SAVED: ", this.state.currentSchedule);
    });
  };

  handleClose = () => {
    this.setState({ open: false }, () => {
      this.closeMainMenuParent();
    });
  };

  handleCompanySelect = event => {
    var found = false;
    for (var i = 0; i < this.props.schedule.length; i++) {
      if (this.props.schedule[i].company === event.target.value) {
        this.setState({
          currentSchedule: this.props.schedule[i],
        }, () => {
          console.log("schedule: ", this.state.currentSchedule);
          });
        found = true;
        break;
      }
    }
    if (!found) {
      this.setState({
        currentSchedule: {}
      });
      console.log("no schedule");
    }
    this.setState({ company: event.target.value });
  };

  handleToggle = value => () => {
    this.props.toggleUser(this.props.memberNameMap[value]['id'], this.state.company);
    /*const { checked } = this.state;
    const currentIndex = checked.indexOf(value);
    const newChecked = [...checked];
    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }
    console.log("NEW CHECKED", newChecked);
    this.setState({
      checked: newChecked,
    });*/
  };

  isChecked = (value) => {
    var schedule = undefined;
    for (var i = 0; i < this.props.schedule.length; i++) {
      if (this.props.schedule[i]['company'] === this.state.company) {
        schedule = this.props.schedule[i];
      }
    }
    if (schedule === undefined) {
      return false;
    }
    return this.props.memberNameMap[value] !== undefined && schedule.checkedUserIds.indexOf(this.props.memberNameMap[value]['id']) !== -1;
  }

  handleOpenOnCallSchedule = () => {
    this.setState({ open: true });
  };

  closeMainMenuParent = () => {
    this.props.callbackFromParent();
  }

  myCallback = (dataFromChild) => {
    // console.log("dataFromChild: ", dataFromChild); // {beginTime, endTime, id, scheduleId, prime, secondary, tertiary}
    if (dataFromChild['delete'] === true) {
      // console.log("We are calling delete");
      var tempSchedule = { ...this.state.currentSchedule }
      var newLineItems = [];
      for (var i = 0; i < tempSchedule.onCallLineItems.length; i++) {
        var lineItem = tempSchedule.onCallLineItems[i];
        if (dataFromChild['id'] !== lineItem['id']) {
          newLineItems.push(lineItem);
        }
      }
      tempSchedule.onCallLineItems = newLineItems;
      this.setState({ currentSchedule: tempSchedule }, () => {
        // console.log("this.state.currentSchedule UPDATED with DELETE: ", this.state.currentSchedule);
      });
    } else if (dataFromChild['time_change'] === true) {
      // console.log("We are attemping a time change");
      // console.log(dataFromChild);
      var tempSchedule = { ...this.state.currentSchedule }
      for (var i = 0; i < tempSchedule.onCallLineItems.length; i++) {
        var lineItem = tempSchedule.onCallLineItems[i];
        if (dataFromChild['id'] === lineItem['id']) {
          tempSchedule.onCallLineItems[i][dataFromChild['target']] = dataFromChild['date'];
          this.setState({ currentSchedule: tempSchedule }, () => {
            // console.log("this.state.currentSchedule UPDATED: ", this.state.currentSchedule);
          });
        }
      }
    } else {
      var tempSchedule = { ...this.state.currentSchedule }
      for (var i = 0; i < tempSchedule.onCallLineItems.length; i++) {
        var lineItem = tempSchedule.onCallLineItems[i];
        if (dataFromChild['id'] === lineItem['id']) {
          tempSchedule.onCallLineItems[i] = dataFromChild;
          this.setState({ currentSchedule: tempSchedule }, () => {
            // console.log("this.state.currentSchedule UPDATED: ", this.state.currentSchedule);
          });
        }
      }
    }
  };

  getNameFromMember = (member) => {
    return member['firstName'] + " " + member['lastName'];
  };

  getSalesPeople = members => {
    var listOfSales = [];
    for (var i = 0; i < members.length; i++) {
      var member = members[i];
      if (member['roles'] !== null && member['roles'].includes("S")) {
        listOfSales.push(this.getNameFromMember(member));
      }
    }
    return listOfSales;
  };

  render() {
    let salesMembers = this.getSalesPeople(this.props.members);
    let onCallSchedule;
    let onCallScheduleDrawer;
    let responsiveOnCallSchedule;
    const company = this.state.company;
    const { buttonLoading, buttonSuccess } = this.state;
    const { width } = this.props;
    const timeSlotsArr = [];

    if (this.state.currentSchedule.hasOwnProperty('onCallLineItems')) {
      //console.log("schedule: ", this.state.currentSchedule);
      this.state.currentSchedule.onCallLineItems.map((timeSlot) => {
        //console.log("time slot: ", timeSlot); // {beginTime, endTime, id, prime, scheduleId, secondary, tertiary}
        timeSlotsArr.push(<OnCallScheduleItem key={timeSlot.id} timeSlot={timeSlot} callbackFromParent={this.myCallback} />);
      });
    }

    if (company !== "Select") {
      onCallSchedule =
        <div>
          <DialogContent>
            <div style={{ flexgrow: '1' }}>
              <Grid container spacing={0}>
                <Grid item xs={2}><h6><b>Begin</b></h6>
                </Grid>

                <Grid item xs={2}><h6><b>End</b></h6>
                </Grid>

                <Grid item xs={2}><h6><b>Primary</b></h6>
                </Grid>

                <Grid item xs={2}><h6><b>Alternate</b></h6>
                </Grid>

                <Grid item xs={2}><h6><b>Alternate 2</b></h6>
                </Grid>

                <Grid item xs={2}><h6><b>Remove</b></h6>
                </Grid>
              </Grid>
            </div>
            {/*
          {onCallRows}
          */}
            {timeSlotsArr}
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleAddTimeframe} color="primary">
              Add Timeframe
            </Button>
            <Button onClick={this.handleSendEmail} color="primary">
              Send Email
            </Button>
            <Button onClick={this.handleSaveOnCall} color="primary">
              Save
            </Button>
            <Button onClick={this.handleClose} color="primary">
              Done
            </Button>
          </DialogActions>
        </div>
    }

    if (company !== "Select") {
      onCallScheduleDrawer =
        <div>
          <div style={{ paddingTop: '10px' }}>{timeSlotsArr}</div>
          <div style={{ display: 'block', padding: '20px', height: '60px', width: '100%' }} /> {/*phantom div to make buttons sticky footer */}
          <div style={{ position: 'fixed', left: '0', bottom: '0', height: '50px', width: '100%', backgroundColor: '#3f51b5' }}>
            <Grid container spacing={0} style={{ paddingLeft: '5px', paddingBottom: '0px' }}>
              <Grid item xs={3}>
                <Tooltip
                  title={
                    <React.Fragment>
                      <h6>
                        Add Timeframe
                      </h6>
                    </React.Fragment>
                  }
                >
                  <IconButton onClick={this.handleAddTimeframe}  style={{ color: 'white' }}>
                    <AddIcon />
                  </IconButton>
                </Tooltip>
              </Grid>
              <Grid item xs={3}>
                <Tooltip
                  title={
                    <React.Fragment>
                      <h6>
                        Send Email
                      </h6>
                    </React.Fragment>
                  }
                >
                  <IconButton onClick={this.handleSendEmail} style={{ color: 'white' }}>
                    <EmailIcon />
                  </IconButton>
                </Tooltip>
              </Grid>
              <Grid item xs={3}>
                <Tooltip
                  title={
                    <React.Fragment>
                      <h6>
                        Save
                      </h6>
                    </React.Fragment>
                  }
                >
                  <IconButton onClick={this.handleSaveOnCall} style={{ color: 'white' }}>
                    <SaveIcon />
                  </IconButton>
                </Tooltip>
              </Grid>
              <Grid item xs={3}>
                <Tooltip
                  title={
                    <React.Fragment>
                      <h6>
                        Done
                      </h6>
                    </React.Fragment>
                  }
                >
                  <IconButton onClick={this.handleClose} style={{ color: 'white' }}>
                    <DoneIcon />
                  </IconButton>
                </Tooltip>
              </Grid>
            </Grid>
          </div>
        </div>;
    }

    if (width !== "xs") {
      responsiveOnCallSchedule =
        <div>
          <Dialog
            open={this.state.open}
            onClose={this.handleClose}
            aria-labelledby="form-dialog-title"
            maxWidth={false}
            fullWidth={true}
            maxWidth={'md'}
          >
            <Grid container spacing={0}>
              <Grid item xs={8} style={{ paddingBottom: '20px' }}>
                <DialogTitle style={{ width: '200px' }}><b>On Call Schedule</b></DialogTitle>
              </Grid>
              <Grid item xs={4} style={{ paddingTop: '20px' }}>
                <FormControl style={{ fullWidth: "false", display: "flex", wrap: "nowrap" }}>
                  <Select
                    value={this.state.company}
                    onChange={this.handleCompanySelect}
                    autoWidth={true}
                    style={{ width: '150px' }}
                  >
                    <MenuItem value={"Select"}><em>Select On Call Company</em></MenuItem>
                    <MenuItem onClick={this.handleDaVinci} value={"Da Vinci"}>Da Vinci</MenuItem>
                    <MenuItem onClick={this.handleGbbis} value={"GbBIS"}>GbBIS</MenuItem>
                    <MenuItem onClick={this.handleGeography} value={"Geography"}>Geography</MenuItem>
                    <MenuItem onClick={this.handleLiveChat} value={"Live Chat"}>Live Chat</MenuItem>
                    <MenuItem onClick={this.handleMarketMaps} value={"MarketMaps"}>MarketMaps</MenuItem>
                    <MenuItem onClick={this.handleProduction} value={"Production"}>Production</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
            </Grid>
            {onCallSchedule}
          </Dialog>

          <Dialog
            open={this.state.sendEmailOpen}
            onClose={this.handleSendEmailClose}
            aria-labelledby="form-dialog-title"
          >
            <DialogTitle id="form-dialog-title">Send Email To Recipients</DialogTitle>
            <DialogContent>
              <DialogContentText>
                Please select the employees that should receive the on call schedule.
              </DialogContentText>
              <List subheader={<li />} style={{ width: '100%', minWidth: '400px', position: 'relative', overflow: 'auto', maxHeight: '300px' }}>
                {salesMembers.map(value => (
                  <ListItem key={value} /*role={undefined}*/ dense button onClick={this.handleToggle(value)} style={{ padding: '0px', margin: '0px' }}>
                    <Checkbox
                      checked={this.isChecked(value)}
                      //checked={this.state.checked.indexOf(value) !== -1}
                      tabIndex={-1}
                      disableRipple
                    />
                    <ListItemText primary={`${value}`} />
                  </ListItem>
                ))}
              </List>

            </DialogContent>
            <DialogActions>
              <Button onClick={this.handleSendEmailClose} color="primary">
                Close
              </Button>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <div style={{ position: 'relative' }}>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={this.handleSendEmailSent}
                    style={{ backgroundColor: 'green' }}
                    disabled={buttonLoading}
                  >
                    Send Email
                  </Button>
                  {buttonLoading && <CircularProgress size={24} style={{ color: '#bababa', position: 'absolute', top: '50%', left: '50%', marginTop: '-12px', marginLeft: '-12px' }} />}
                </div>
              </div>
            </DialogActions>
          </Dialog>
        </div>;
    } else {
      responsiveOnCallSchedule = // narrow window drawer layout
        <div>
          <Drawer open={this.state.open} onClose={this.handleClose}>
            <div
              style={{ width: '190px', flexGrow: '0', marginBottom: '0px', marginLeft: '15px', marginRight: '15px' }}
              role="presentation"
            >
              <Grid container spacing={0}>
                <Grid item md={6}>
                  <h5 style={{ marginTop: '8px', marginBottom: '0px', fontSize: '17px' }}><b>On Call Schedule</b></h5>
                </Grid>
                <Grid item xs={3}>
                  <CloseIcon style={{ marginTop: '5px', marginBottom: '0px', marginLeft: '30px' }} onClick={this.handleClose} />
                </Grid>
              </Grid>
              <FormControl style={{ fullWidth: "false", display: "flex", wrap: "nowrap", paddingTop: "30px" }}>
                <Select
                  value={this.state.company}
                  onChange={this.handleCompanySelect}
                  autoWidth={true}
                  style={{ width: '190px' }}
                >
                  <MenuItem value={"Select"}><em>Select On Call Company</em></MenuItem>
                  <MenuItem onClick={this.handleDaVinci} value={"Da Vinci"}>Da Vinci</MenuItem>
                  <MenuItem onClick={this.handleGbbis} value={"GbBIS"}>GbBIS</MenuItem>
                  <MenuItem onClick={this.handleGeography} value={"Geography"}>Geography</MenuItem>
                  <MenuItem onClick={this.handleLiveChat} value={"Live Chat"}>Live Chat</MenuItem>
                  <MenuItem onClick={this.handleMarketMaps} value={"MarketMaps"}>MarketMaps</MenuItem>
                  <MenuItem onClick={this.handleProduction} value={"Production"}>Production</MenuItem>
                </Select>
              </FormControl>
              {/*
              <Grid container spacing={0}>
                <Grid item xs={4} style={{ paddingTop: '10px'}}>
                  <FormControl style={{ fullWidth: "false", display: "flex", wrap: "nowrap" }}>
                    <Select
                      value={this.state.company}
                      onChange={this.handleCompanySelect}
                      autoWidth={true}
                      style={{ width: '190px' }}
                    >
                      <MenuItem value={"Select"}><em>Select On Call Company</em></MenuItem>
                      <MenuItem onClick={this.handleDaVinci} value={"Da Vinci"}>Da Vinci</MenuItem>
                      <MenuItem onClick={this.handleGbbis} value={"GbBIS"}>GbBIS</MenuItem>
                      <MenuItem onClick={this.handleGeography} value={"Geography"}>Geography</MenuItem>
                      <MenuItem onClick={this.handleLiveChat} value={"Live Chat"}>Live Chat</MenuItem>
                      <MenuItem onClick={this.handleMarketMaps} value={"MarketMaps"}>MarketMaps</MenuItem>
                      <MenuItem onClick={this.handleProduction} value={"Production"}>Production</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>
              */}
            </div>
            {onCallScheduleDrawer}
          </Drawer>
        </div>;
    }
  
    return (
      <div>
        <MenuItem onClick={this.handleOpenOnCallSchedule}>On Call Schedule</MenuItem>
        {responsiveOnCallSchedule}
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  getSchedule: () => dispatch(scheduleActions['LOAD_SCHEDULE']()),
  sendEmail: (userId, company) => dispatch(scheduleActions['SEND_EMAIL'](userId, company)),
  toggleUser: (userId, company) => dispatch(scheduleActions['TOGGLE_USER'](userId, company)),
  updateSchedule: (company, schedule) => dispatch(scheduleActions['UPDATE_SCHEDULE'](company, schedule)),
})

function mapStateToProps(state) {
  return {
    schedule: state.schedule,
    members: state.members,
    memberIdMap: state.memberIdMap,
    memberNameMap: state.memberNameMap,
  };
}

//export default connect(mapStateToProps, mapDispatchToProps)(OnCallScheduleList);

OnCallScheduleList.propTypes = {
  width: PropTypes.string.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(withWidth()(OnCallScheduleList));


// WEBPACK FOOTER //
// ./src/components/OnCallScheduleList.js